import { env } from 'process';

export const environments = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
};

export const current = environments[env.NODE_ENV] || environments.development;

export default current;
